/* /join/:token — link vào lớp hàng tuần mentor gửi: ghi danh rồi chuyển vào lớp. */
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Icon } from "@/components/icon"
import { EmptyState, LoadingState, Page, usePageTitle } from "@/components/page"
import { api, loginUrl } from "@/lib/api"

export default function JoinPage() {
  usePageTitle("Vào lớp", "Mở lớp học Simba từ đường link mentor gửi cho học viên Sư Tử Con.", { noIndex: true })
  const { token = "" } = useParams()
  const [error, setError] = useState("")
  useEffect(() => {
    api(`/api/join/${encodeURIComponent(token)}`, "POST")
      .then((data) => location.replace(data.destination))
      .catch((e) => {
        if (e.status === 401) location.href = loginUrl()
        else setError(e.message)
      })
  }, [token])

  return (
    <Page className="max-w-xl">
      {error ? (
        <EmptyState
          mascot="elephant-thinking"
          title="Chưa thể vào lớp"
          description={error}
          action={
            <Button onClick={() => location.reload()}>
              <Icon name="arrow-right" /> Thử lại
            </Button>
          }
        />
      ) : (
        <div className="flex flex-col items-center gap-2 py-10 text-center">
          <h1 className="font-heading text-2xl font-bold text-ink">Simba đang mở lớp…</h1>
          <p className="text-muted-foreground">Google đã xác nhận tài khoản. Con sẽ vào lớp trong giây lát.</p>
          <LoadingState label="Đang vào lớp…" />
        </div>
      )}
    </Page>
  )
}
